import { Button, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useMemo } from "react";
import CustomTable from "../../customTable/CustomTable";

export default function TableInsurer({
  totalElements,
  pageable,
  setPageable,
  rowData,
  handlePatientClick,
}) {
  const [colDefs, defaultColDef] = useMemo(
    () => [
      [
        {
          field: "patientInfo.name",
          headerName: "نام و نام خانوادگی",
          width: 225,
        },
        {
          field: "patientInfo.phone",
          headerName: "شماره تلفن",
          width: 150,
        },
        {
          field: "patientInfo.fatherName",
          headerName: "نام پدر",
          width: 150,
        },
        {
          headerName: "بیمه",
          width: 150,
          cellRenderer: (x) => {
            return (
              <Typography
                sx={{ lineHeight: "unset" }}
                key={`insurance_${x.id}`}
                fontFamily="Vazirmatn"
              >
                {x?.data?.patientInfo?.insurance === "TAKMIL"
                  ? "تکمیلی"
                  : x?.data?.patientInfo?.insurance === "MILITARY"
                    ? "نیروهای مسلح"
                    : x?.data?.patientInfo?.insurance === "TAMIN"
                      ? "تامین اجتماعی"
                      : x?.data?.patientInfo?.insurance === "SALAMAT"
                        ? "سلامت"
                        : "ندارد "}
              </Typography>
            );
          },
        },
        {
          field: "patientInfo.identifier",
          headerName: "کد ملی",
          width: 150,
        },
        {
          field: "patientInfo.job",
          headerName: "شغل",
          width: 150,
        },
        {
          field: "patientInfo.patientNo",
          headerName: "شماره پرونده",
          width: 150,
        },
        // {
        //   field: "patientInfo.birthDate",
        //   headerName: "تاریخ تولد",
        //   width: 150,
        //   cellRenderer: (x) => {
        //     return (
        //       <>
        //       <Typography fontFamily="Vazirmatn" >{x?.data?.patientInfo?.birthDate.split("-",2)[0]}</Typography>
        //       </>
        //     )}
        // },
        {
          headerName: "عملیات",
          width: 200,
          cellRenderer: (x) => {
            return (
              <Button
                key={`op_${x.id}`}
                color={"primary"}
                variant="contained"
                sx={{ fontFamily: "Vazirmatn" }}
                onClick={() => handlePatientClick(x.data?.patientInfo?.id)}
              >
                {"فعال سازی بیمه"}
              </Button>
            );
          },
        },
      ],
      {
        filter: true,
        editable: true,
      },
    ],
    [handlePatientClick],
  );

  return (
    <>
      <CustomTable
        onPageChange={(pageIndex, pageSize) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: pageSize,
          });
        }}
        pageSize={pageable.pageSize}
        totalElements={totalElements}
        currentPage={pageable.pageIndex}
        rowData={rowData}
        columns={colDefs}
        defaultColDef={defaultColDef}
      />
    </>
  );
}
